import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js';


const CatalogoSPagoObra1 = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'CONTRATISTA', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
        { label: 'FECHA DE SOLICITUD', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idsolicitudpagoobras.includes(target.value)
                            || x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
                            || x.observaciones.toLowerCase().includes(target.value.toLowerCase())
                            || moment.utc(x.fecha).format('DD-MM-YYYY').includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarSPagoObra1 = () => {


        let endpoint = `${op.conexion}/api/catalogo/seleccionarsolicitudpagoobras2?idefi=${idefiscal}&tiposoli=${props.tiposoli}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                var data = []
                for (let i = 0; i < response.data.length; i++) {
                    data.push({
                        idsolicitudpagoobras: response.data[i].idsolicitudpagoobras,
                        idobraasignada: response.data[i].idobraasignada,
                        razonsocial: response.data[i].razonsocial,
                        status: response.data[i].status,
                        fecha: response.data[i].fecha,
                        observaciones: response.data[i].observaciones,
                        tipo: response.data[i].tipo,
                        concepto: response.data[i].concepto,
                        idefiscal: response.data[i].idefiscal,
                    })
                }
                setRecords(data)
            }


        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectOrden = () => {

        var idsolicitudpagoobras = values[0].idsolicitudpagoobras;
        var idobraasignada = values[0].idobraasignada;
        var status = values[0].status;
        var fecha = values[0].fecha;
        var observaciones = values[0].observaciones;
        var tipo = values[0].tipo;
        var concepto = values[0].concepto;
        var idefiscal = values[0].idefiscal;

        blanquear();
        props.onHideAceptar(idsolicitudpagoobras, idobraasignada, status, fecha, observaciones, tipo, concepto, idefiscal);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idsolicitudpagoobras = recordsAfterPagingAndSorting()[index].idsolicitudpagoobras;
        var idobraasignada = recordsAfterPagingAndSorting()[index].idobraasignada;
        var status = recordsAfterPagingAndSorting()[index].status;
        var fecha = recordsAfterPagingAndSorting()[index].fecha;
        var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
        var tipo = recordsAfterPagingAndSorting()[index].tipo;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;


        var datos = [];
        datos.push({
            idsolicitudpagoobras: idsolicitudpagoobras,
            idobraasignada: idobraasignada,
            status: status,
            fecha: fecha,
            observaciones: observaciones,
            tipo: tipo,
            concepto: concepto,
            idefiscal: idefiscal
        });
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarSPagoObra1()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Solicitud de Pago de Obras</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '60px' }}>{item.idsolicitudpagoobras}</td>
                                        <td className='py-2 text-center' style={{ width: '250px' }}>{item.razonsocial.trim()}</td>
                                        <td className='py-2 text-center' style={{ width: '250px' }}>{item.observaciones.trim()}</td>
                                        <td className='py-2 text-center' style={{ width: '80px' }}>{moment.utc(item.fecha).format('DD-MM-YYYY')}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectOrden}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoSPagoObra1;